import { dateFormatForSearch,  dateFormatForDisplay, getMedDayStr, getMonthStr, getReadableDateStrFullWeekday, getReservationDateStr, getReadableDateStr } from "./date-format.js";

var availability = {};

availability.visibleCalendarPanes = 6;
availability.calendarPagingCount = 2;

availability.calendarFromDate = null;
availability.calendarToDate = null;
availability.holidayPrice = null;
availability.hvrCells = [];
availability.selCells = [];
availability.cottageCode = null;
availability.currentLeftIndex = 0;
availability.numberOfMonths = 0;
availability.calControl = false;
availability.datePickerDate = null;
availability.readableChangeoverDays = "";
availability.feedURL = "/feeds/cottageFeed.aspx?type=avail";
availability.holidayPricingFeed = "/feeds/pricingFeed.aspx";
availability.cancelAnytimeFeed = "/feeds/cancelAnytime.aspx";

availability.pricingData = null;
availability.pricedHolidays = [];
availability.el = {};
availability.activeHolidayData = null;

availability.initElements = function () {
    availability.el = {
        bookingFormWelcome: document.querySelector("#booking-form-welcome"),
        arrivePanel: document.querySelector("#arrive-panel"),
        departPanel: document.querySelector("#depart-panel"),
        arriveDate: document.querySelector("#arrive-date"),
        departDate: document.querySelector("#depart-date"),
        arrivalDateField: document.querySelector("#arrival-date-field"),
        departureDateField: document.querySelector("#departure-date-field"),
        bookingWarningWrapper: document.querySelector("#booking-warning-wrapper"),
        bookingWarningTitle: document.querySelector("#booking-warning-title"),
        bookingWarningMessage: document.querySelector("#booking-warning-message"),
        lowOccWrapper: document.querySelector("#low-occ-wrapper"),
        lowOccSelect: document.querySelector("#low-occ-select"),
        lowOccMessage: document.querySelector("#low-occ-message"),
        selectedPriceModifierId: document.querySelector(
            "#selected-price-modifier-id",
        ),
        selectedCancelAnytimeId: document.querySelector(
            "#selected-cancel-anytime-id",
        ),
        selectedCancelAnytimeTotalCost: document.querySelector(
            "#selected-cancel-anytime-total-cost",
        ),
        cancelAnytimePricing: document.querySelector("#cancel-anytime-pricing"),
        caStandardPrice: document.querySelector("#ca-standard-price"),
        caFlexiblePrice: document.querySelector("#ca-flexible-price"),
        caFlexibleDescription: document.querySelector("#ca-flexible-description"),
        pricingSpinner: document.querySelector("#pricing-spinner"),
        pricingBreakdownWrapper: document.querySelector(
            "#pricing-breakdown-wrapper",
        ),
        reserveButton: document.querySelector("#reserve-button"),
    };
};

// --------------------------------------------

availability.setCalendarMode = function () {
    var calendarTitle = $("#dpTitle");
    switch ($("#ddlDays").val()) {
        case "3":
            //A long weekend.
            calendarTitle.text("Arriving: Fri");
            break;

        case "4":
            //A mid-week break.
            calendarTitle.text("Arriving: Mon");
            break;

        default:
            calendarTitle.text("Arriving: Mon / Fri");
    }
};

availability.showCalendars = function (year, cottageCode, callback) {
    var data = "code=" + cottageCode;
    data += "&year=" + year;
    data += "&business=ah";
    availability.cottageCode = cottageCode;
    availability.calControl = cottageCode == 0;
    // Start the Ajax
    jQuery.ajax({
        url: availability.feedURL,
        type: "GET",
        data: data,
        cache: false,
        success: function (xml) {
            availability.onReturn_showCalendars(xml);
            if (typeof callback == "function") callback();
        },
    });
};

availability.onReturn_showCalendars = function (xml) {
    // Save the calendar xml for the duration of this particular property
    if ($(xml).find("year").length < 1) {
        //alert('No calendar found');
    } else {
        var loopCount = 0;
        var previousMonthAvailability = null; // This is needed when bookings straddle months
        var previousMonthShortBreakAvailability = null;
        var isCalendar = availability.calControl;
        var visibleMonths = availability.visibleCalendarPanes;
        var monthCount = 0;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        $(xml)
            .find("year")
            .each(function () {
                var year = $(this).attr("value");
                availability.readableChangeoverDays = $(this).attr(
                    "readableChangeoverDays",
                );
                $(this)
                    .find("month")
                    .each(function () {
                        monthCount += 1;
                        var monthName = $(this).attr("name");
                        var availability = $(this).attr("thisMonthAvailability");
                        var changeoverdays = $(this).attr("thisMonthChangeoverDays");
                        var shortbreakavailability = $(this).attr(
                            "thisMonthShortBreakAvailability",
                        );

                        // Create a Date object based on the start date
                        // It might be better to store a record of all these dates - useful when restoring the calendars if the dates selected are not valid (rather than a simple array at present);
                        calendarStart = $(this).attr("calendarStart");
                        startYear = calendarStart.substr(6, 4);
                        startMonth = calendarStart.substr(3, 2);
                        startDay = calendarStart.substr(0, 2);
                        startMonth = parseInt(startMonth, 10) - 1; // Remember to substract 1 from the month
                        startDay = parseInt(startDay, 10);
                        var startDate = new Date(startYear, startMonth, startDay);

                        // Create a container div

                        var calDiv = $("<div>").addClass("calendar");
                        calDiv.attr("data-index", loopCount);
                        // No RH margin on every third month.
                        var firstMonthInRow = loopCount % 3 == 0;
                        var lastMonthInRow = loopCount % 3 == 2;

                        var tableWidth = 240;
                        var cellWidth = 34;
                        if (isCalendar) {
                            tableWidth = 200;
                            cellWidth = 28;
                        }
                        // Create the main container table
                        var tblContainer = $(
                            '<table width="' +
                            tableWidth +
                            '" border="0" cellpadding="0" cellspacing="0" class="cal">',
                        );
                        var monthRow = $("<tr>");
                        if (isCalendar) {
                            monthRow.append(
                                $('<th colspan="1" scope="col" class="cal-prev">').html("&lt;"),
                            );
                            monthRow.append(
                                $('<th colspan="5" scope="col" class="month">').html(
                                    monthName + "&nbsp;<span>" + year + "</span>",
                                ),
                            );
                            monthRow.append(
                                $('<th colspan="1" scope="col" class="cal-next">').html("&gt;"),
                            );
                        } else {
                            // Month name and year
                            monthRow.append(
                                $('<th colspan="7" scope="col" class="month">').html(
                                    monthName + "&nbsp;<span>" + year + "</span>",
                                ),
                            );
                        }
                        tblContainer.append(monthRow);
                        // Now create a table for the headings
                        var tblHeadings = $("<table>").attr("class", "cal-day-heading");

                        // Header columns
                        var daysRow = $("<tr>");
                        for (var i = 0; i < 7; i++) {
                            var dayStr = getMedDayStr(startDate.getDay());

                            daysRow.append(
                                $('<th width="' + cellWidth + '" scope="col">').html(dayStr),
                            );
                            startDate.setDate(startDate.getDate() + 1);
                        }

                        tblContainer.append(daysRow);

                        // Reset start date
                        startDate.setDate(startDate.getDate() - 7);

                        // Now loop through the length of the availability string - adding a day each time
                        var dayCounter = 0;
                        var selectedMonth = monthName.toLowerCase();
                        for (var i = 0; i < availability.length; i++) {
                            if (dayCounter == 0) {
                                var tableRow = $("<tr>");
                            }
                            // Check these days are within the current month
                            if (getMonthStr(startDate.getMonth()) != selectedMonth) {
                                tableRow.append(
                                    $('<td class="adj">').html(startDate.getDate()),
                                );
                            } else {
                                var isPastDate = startDate < today;
                                var pastClass = isPastDate ? " past-date" : "";
                                // See if this is a standard changeover day
                                var isChangeOverDay = changeoverdays.substr(i, 1) == "1";
                                // See if the previous day was booked
                                var isPreviousDayBooked = false;
                                if (i > 0) {
                                    // Need to consider when the previous day was in the previous month
                                    isPreviousDayBooked = availability.substr(i - 1, 1) != "1";
                                } else if (previousMonthAvailability != null) {
                                    // Check the last day in the previous month
                                    isPreviousDayBooked =
                                        previousMonthAvailability.substr(
                                            previousMonthAvailability.length - 1,
                                            1,
                                        ) != "1";
                                }
                                // See if this day is available
                                var isAvailable = availability.substr(i, 1) == "1";
                                // Get the date for the element ID (on available dates)
                                var elementID =
                                    startDate.getFullYear() +
                                    "-" +
                                    startDate.getMonth() +
                                    "-" +
                                    startDate.getDate();

                                // See if this day is a valid shortbreak day
                                var allowsShortBreak =
                                    shortbreakavailability.substr(i, 1) == "1";
                                var prevDayAllowsShortBreak = false;
                                if (i == 0 && previousMonthShortBreakAvailability != null) {
                                    prevDayAllowsShortBreak =
                                        previousMonthShortBreakAvailability.substr(
                                            previousMonthAvailability.length - 1,
                                            1,
                                        ) == "1";
                                } else if (i > 0)
                                    prevDayAllowsShortBreak =
                                        shortbreakavailability.substr(i - 1, 1) == "1";
                                var sb = "";

                                if (allowsShortBreak) {
                                    sb = " shortbreak";
                                    if (!prevDayAllowsShortBreak) sb = sb + " any-sbava";
                                } else if (prevDayAllowsShortBreak) {
                                    sb = " sbava-any";
                                }

                                // Run through the combinations...
                                if (isAvailable && !isPreviousDayBooked && !isChangeOverDay) {
                                    tableRow.append(
                                        $(
                                            '<td class="active a-ava' +
                                            sb +
                                            pastClass +
                                            '" id="' +
                                            elementID +
                                            '">',
                                        ).html(startDate.getDate()),
                                    );
                                } else if (isAvailable && isPreviousDayBooked) {
                                    tableRow.append(
                                        $(
                                            '<td class="active a-una-ava' +
                                            sb +
                                            pastClass +
                                            '" id="' +
                                            elementID +
                                            '">',
                                        ).html(startDate.getDate()),
                                    );
                                } else if (isAvailable && isChangeOverDay) {
                                    tableRow.append(
                                        $(
                                            '<td class="active a-ava' +
                                            sb +
                                            pastClass +
                                            ' changeover" id="' +
                                            elementID +
                                            '">',
                                        ).html(startDate.getDate()),
                                    );
                                } else if (!isAvailable && !isPreviousDayBooked) {
                                    tableRow.append(
                                        $(
                                            '<td class="active a-ava-una' +
                                            sb +
                                            pastClass +
                                            '" id="' +
                                            elementID +
                                            '">',
                                        ).html(startDate.getDate()),
                                    );
                                } else if (!isAvailable) {
                                    tableRow.append(
                                        $(
                                            '<td class="a-una' +
                                            pastClass +
                                            '" id="' +
                                            elementID +
                                            '">',
                                        ).html(startDate.getDate()),
                                    );
                                }
                            }

                            startDate.setDate(startDate.getDate() + 1);
                            if (dayCounter < 6) {
                                dayCounter++;
                            } else {
                                dayCounter = 0;
                                tblContainer.append(tableRow);
                            }
                        }

                        calDiv.append(tblContainer);

                        if (jQuery("#availability-container").length > 0) {
                            calDiv.appendTo("#availability-container");
                        }
                        if (jQuery("#arrivalDateCalendar").length > 0) {
                            calDiv.appendTo("#arrivalDateCalendar");
                        }

                        previousMonthAvailability = availability;
                        previousMonthShortBreakAvailability = shortbreakavailability;
                        loopCount++;
                    });
            });
        availability.numberOfMonths = loopCount;
        availability.setPagingControlVisiblity();

        // Now set event handlers for all the btn-date links
        if (!jQuery("#availability-container").hasClass("not-interactive")) {
            if (isCalendar) {
                $("#availability-container .changeover").click(function (event) {
                    var obj = $(this);
                    availability.onClickDate(event, obj);
                });

                $("#availability-container .changeover").hover(function (event) {
                    var obj = $(this);
                    availability.onHoverDate(event, obj);
                });
            } else {
                $("#availability-container .active").click(function (event) {
                    var obj = $(this);
                    availability.onClickDate(event, obj);
                });

                $("#availability-container .active").hover(function (event) {
                    var obj = $(this);
                    availability.onHoverDate(event, obj);
                });
            }

            $(".cal-prev").click(function (event) {
                availability.moveCalendarView("prev");
            });

            $(document).on("click", ".cal-next", function (event) {
                availability.moveCalendarView("next");
            });

            $("#cal-load-container").mouseout(function () {
                availability.clearHighlight(true);
            });
            $("#arrivalDateCalendar").mouseout(function () {
                availability.clearHighlight(true);
            });
        }

        if ($("#arrival-date-field").length > 0) {
            if ($("#arrival-date-field").val().length > 0) {
                var dateParts = $("#arrival-date-field").val().split("/");
                availability.calendarFromDate = new Date(
                    dateParts[2],
                    dateParts[1] - 1,
                    dateParts[0],
                );
            }
        }
        if ($("#departure-date-field").length > 0) {
            if ($("#departure-date-field").val().length > 0) {
                var dateParts = $("#departure-date-field").val().split("/");
                availability.calendarToDate = new Date(
                    dateParts[2],
                    dateParts[1] - 1,
                    dateParts[0],
                );
            }
        }

        if (parseInt(availability.el.selectedCancelAnytimeId?.value) !== 0) {
            // set flexible pricing to selected if the selectedCancelAnytimeId is not 0
            if (availability.el.cancelAnytimePricing) {
                const flexibleInput =
                    availability.el.cancelAnytimePricing.querySelector(
                        `input[value="flexible"]`,
                    );
                if (flexibleInput) {
                    flexibleInput.checked = true;
                }
            }
        }

        availability.showSelectedDates(
            availability.calendarFromDate,
            availability.calendarToDate,
        );
        availability.highlightDateRange(
            availability.calendarFromDate,
            availability.calendarToDate,
            false,
        );
    }

    $("#availability-container").show();
};

availability.moveCalendarView = function (direction) {
    var calendars = $(".calendar");
    var visibleCalendars = $(".calendar:not(.hide)");
    var firstVisible = calendars.not(".hide").first().index();
    var lastVisible = calendars.not(".hide").last().index();
    // if last visible index is an even number, then odd no of calendars are visible, when going backwards we need to restore even cal count
    if (lastVisible % 2 == 0) lastVisible = lastVisible + 1;

    var calendarsToHide, calendarsToShow;
    switch (direction) {
        case "prev":
            calendarsToHide = calendars.slice(
                lastVisible + 1 - availability.calendarPagingCount,
                lastVisible + 1,
            );
            calendarsToShow = calendars.slice(
                firstVisible - availability.calendarPagingCount,
                firstVisible,
            );
            break;
        case "next":
            calendarsToHide = calendars.slice(
                firstVisible,
                firstVisible + availability.calendarPagingCount,
            );
            calendarsToShow = calendars.slice(
                lastVisible + 1,
                lastVisible + 1 + availability.calendarPagingCount,
            );
    }

    if (
        visibleCalendars.length - calendarsToHide.length + calendarsToShow.length >=
        availability.visibleCalendarPanes - 1
    ) {
        calendarsToHide.addClass("hide");
        calendarsToShow.removeClass("hide");
    }
    availability.setPagingControlVisiblity();
};

availability.setPagingControlVisiblity = function () {
    if ($(".calendar").not(".hide").first().index() > 0)
        //first visible is not first, therefore show <prev button
        $(".cal-prev").show();
    else $(".cal-prev").hide();
    if (
        $(".calendar").not(".hide").last().index() < $(".calendar").last().index()
    )
        //last visible is not same as last therefore show next> button
        $(".cal-next").show();
    else $(".cal-next").hide();
};

availability.syncDatePickerWithDays = function () {
    availability.setCalendarMode();
    var ddlDays = $("#ddlDays");
    var dowFriday = 5;
    var dowMonday = 1;
    var daysSelected = ddlDays.val();
    var dateSelected = availability.getDate();

    if (dateSelected) {
        var dowSelected = dateSelected.getDay();
        switch (ddlDays.val()) {
            case "3":
                //A long weekend - only allow Friday.
                if (dowSelected != dowFriday) {
                    availability.setDate(
                        availability.dateOfNextDay(dateSelected, dowFriday, -1),
                    );
                }
                break;

            case "4":
                //A mid-week break - only allow Monday.
                if (dowSelected != dowMonday) {
                    availability.setDate(
                        availability.dateOfNextDay(dateSelected, dowMonday, +1),
                    );
                }
                break;

            default:
        }
    } else {
        //If no date selected choose the next Friday to today.
        availability.setDate(availability.dateOfNextDay(new Date(), dowFriday, +1));
    }
};

availability.dateOfNextDay = function (dateAfter, weekday, direction) {
    var d = dateAfter;
    while (d.getDay() != weekday) {
        d.setDate(d.getDate() + direction);
    }
    return d;
};

availability.getDate = function () {
    return availability.datePickerDate; // $('#arrivalDate').attr('data-date');
};

availability.setDate = function (date) {
    availability.datePickerDate = date;
    $("#arrivalDate").attr("data-date", date);
    $("#arrivalDate").attr("data-dateForSearch", dateFormatForSearch(date));
    $("#arrivalDate").val(dateFormatForDisplay(date));
};

availability.onClickDate = function (event, dateSquare) {
    if (dateSquare.hasClass("past-date")) {
        return;
    }

    var dateParts = dateSquare.attr("id").split("-");
    var dateClicked = new Date(dateParts[0], dateParts[1], dateParts[2]);

    if (availability.calControl) {
        var dowClicked = dateClicked.getDay(); //dayOfWeek Monday = 1
        var dowFriday = 5;
        var dowMonday = 1;
        var ddlDays = $("#ddlDays");
        switch (ddlDays.val()) {
            case "0":
                ddlDays.val(7);
                break;

            case "3":
                //A long weekend - only allow Friday.
                if (dowClicked == dowMonday) {
                    ddlDays.val(4);
                }
                break;

            case "4":
                //A mid-week break - only allow Monday.
                if (dowClicked == dowFriday) {
                    ddlDays.val();
                }
                break;

            default:
            //Allow Monday or Friday.
        }

        availability.setDate(dateClicked);
        $("#arrivalDatePicker").hide();
        return;
    }

    availability.clearHighlight(true);
    availability.clearHighlight(false);

    // Interpret third click as a reset (no alert).
    if (
        availability.calendarFromDate != null &&
        availability.calendarToDate != null
    ) {
        availability.calendarFromDate = null;
        availability.calendarToDate = null;
    }

    // if calendarToDate is before calendarFromDate, reset calendarFromDate and calendarToDate to null
    if (
        availability.calendarFromDate != null &&
        dateClicked < availability.calendarFromDate
    ) {
        availability.calendarFromDate = null;
        availability.clearHighlight(true);
    } else if (availability.calendarFromDate == null) {
        //First click sets the Arrival date.
        availability.calendarFromDate = dateClicked;
    } else if (
        availability.calendarFromDate.toString() === dateClicked.toString()
    ) {
        // deselect the from date
        availability.calendarFromDate = null;
        availability.clearHighlight(true);
    } else {
        //Second click sets the Departure date.
        availability.calendarToDate = dateClicked;
    }

    availability.highlightDateRange(
        availability.calendarFromDate,
        availability.calendarToDate,
        false,
    );
    availability.showSelectedDates(
        availability.calendarFromDate,
        availability.calendarToDate,
    );
};

availability.resetBookingForm = () => {
    const el = availability.el;
    el.bookingFormWelcome.ariaHidden = false;
    el.arrivePanel.ariaHidden = true;
    el.departPanel.ariaHidden = true;
    el.bookingWarningWrapper.ariaHidden = true;
    el.bookingWarningMessage.textContent = "";
    el.lowOccWrapper.ariaHidden = true;
    if (el.cancelAnytimePricing) el.cancelAnytimePricing.ariaHidden = true;
    if (el.pricingSpinner) el.pricingSpinner.ariaHidden = true;
    el.pricingBreakdownWrapper.ariaHidden = true;
    el.reserveButton.ariaHidden = true;
};

availability.showSelectedDates = function (arrivalDate, departureDate) {
    availability.resetBookingForm();
    const el = availability.el;

    el.arriveDate.innerHTML = arrivalDate
        ? getReadableDateStrFullWeekday(arrivalDate)
        : "";
    el.departDate.innerHTML = departureDate
        ? getReadableDateStrFullWeekday(departureDate)
        : "";

    if (arrivalDate) {
        el.arrivePanel.ariaHidden = false;
        el.bookingFormWelcome.ariaHidden = true;
        if (departureDate) {
            el.departPanel.ariaHidden = false;
            el.arrivalDateField.value = getReservationDateStr(arrivalDate);
            el.departureDateField.value = getReservationDateStr(departureDate);

            el.pricingSpinner.ariaHidden = false;
            el.pricingBreakdownWrapper.ariaHidden = true;
            el.pricingBreakdownWrapper.innerHTML = "";

            availability.getHolidayBookingStatus(arrivalDate, departureDate);

            jQuery("html, body").animate(
                {
                    scrollTop: jQuery("#book-form").offset().top - 10,
                },
                500,
            );
        } else {
            el.pricingBreakdownWrapper.ariaHidden = false;
            el.pricingBreakdownWrapper.innerHTML =
                "<p class='booking-user-prompt'>Now, click the day you'd like to leave.</p>";
        }
    }
};

availability.getHolidayBookingStatus = async function (arrivalDate) {
    const data = availability.getHolidayReservationData();
    const queryString = new URLSearchParams(data).toString();

    const bookingxml = await fetch(
        availability.holidayPricingFeed + "?" + queryString,
        {
            method: "GET",
            cache: "no-store",
        },
    )
        .then(function (response) {
            return response.text();
        })
        .then(function (text) {
            var parser = new DOMParser();
            var xml = parser.parseFromString(text, "text/xml");

            return xml;
        })
        .catch(function (error) {
            console.error("Error:", error);
        });

    // parse xml to json to make the data more useable
    availability.pricingData = xmlToJson(
        availability.onReturnHolidayPricingResults(bookingxml),
    );

    availability.pricedHolidays = [].concat(
        availability.pricingData?.pricedHolidays?.pricedHoliday ?? [],
    );

    // if there is only one priced holiday -> set the activePriceModifierId to 0
    if (availability.pricedHolidays.length < 2) {
        availability.el.selectedPriceModifierId.value = 0;
    }

    // if CA is active in the site config flag.
    if (availability.el.cancelAnytimePricing) {
        const caPolicies = await Promise.all(
            availability.pricedHolidays.map((holiday) =>
                availability.getCancelAnytimeDetails(holiday.Price, arrivalDate),
            ),
        );
        availability.pricedHolidays = availability.pricedHolidays.map(
            (holiday, index) => ({
                ...holiday,
                caPolicy: caPolicies[index],
            }),
        );
    }

    availability.renderPriceBreakdown();
};

availability.getCancelAnytimeDetails = async function (
    bookingCost,
    arrivalDate,
) {
    const data = {
        r: bookingCost,
        holidayStartDate: arrivalDate.toISOString().split("T")[0],
    };
    const queryString = new URLSearchParams(data).toString();
    const policy = await fetch(
        availability.cancelAnytimeFeed + "?" + queryString,
        {
            method: "GET",
            cache: "no-store",
        },
    )
        .then((response) => response.text())
        .then((text) => {
            const xml = new DOMParser().parseFromString(text, "application/xml");
            const covers = [...xml.querySelectorAll("coverDetails")].map((el) =>
                Object.fromEntries(
                    [...el.attributes].map((attr) => [attr.name, attr.value]),
                ),
            );
            return covers[0];
        })
        .catch(function (error) {
            console.error("Error fetching Cancel Anytime details:", error);
        });

    return policy;
};

availability.getActiveHolidayData = (hols, priceModifierId) => {
    const id = parseInt(priceModifierId);
    const lowOccHoliday = hols.find(
        (holiday) => parseInt(holiday.PriceModifierID) === id,
    );

    if (lowOccHoliday) {
        return lowOccHoliday;
    } else {
        availability.el.selectedPriceModifierId.value = 0;
        return hols[0];
    }
};

availability.renderPriceBreakdown = function () {

    const el = availability.el;
    el.pricingSpinner.ariaHidden = true;

    const { pricingData, pricedHolidays } = availability;

    const canReserve = pricingData.CanReserve == "Y";
    const showRent = pricingData.ShowRent == "Y";
    const selectedCancellationValue = el.cancelAnytimePricing?.querySelector(
        'input[name="cancellation"]:checked',
    )?.value;

    // -------------------------------------------------------------------------------------------------------  Warning

    if (pricingData.WarningMessage) {
        el.bookingWarningWrapper.ariaHidden = "false";
        el.bookingWarningTitle.textContent = pricingData.WarningMessage;
        el.bookingWarningMessage.textContent = canReserve
            ? "We'll hold your dates and quickly check everything is ok before we confirm the availability and pricing of your booking."
            : "These dates aren't available online, but call us on 01736 754 242 and we might be able to work something out for you";

    }
    // -------------------------------------------------------------------------------------------------------

    availability.activeHolidayData = availability.getActiveHolidayData(
        pricedHolidays,
        availability.el.selectedPriceModifierId.value,
    );

    const { activeHolidayData } = availability;

    if (!activeHolidayData) return;// if there is no active holiday data, return early to avoid errors

    const fullPropertyRentalPrice = parseFloat(pricedHolidays[0].Price);
    const lineItemsTotal = Array.from(
        activeHolidayData.lineItems?.lineItem ?? [],
    ).reduce((acc, lineItem) => acc + parseFloat(lineItem.value), 0);

    const isLowOccDiscountAvailable = pricedHolidays.length > 1;
    const lowOccDiscountValue =
        parseFloat(activeHolidayData.Price) - parseFloat(pricedHolidays[0].Price);


    // -------------------------------------------------------------------------------------------------------  Low Occupancy Discount

    if (isLowOccDiscountAvailable && canReserve) {
        el.lowOccWrapper.ariaHidden = "false";
        el.lowOccSelect.innerHTML = pricedHolidays
            .map((holiday, index) => {
                if (index == 0) {
                    return `<option value="0" data-low-occ-message="" ${parseInt(availability.el.selectedPriceModifierId.value) === 0 ? "selected" : ""}>Full Property</option>`;
                } else {
                    return `<option value="${holiday.PriceModifierID}" data-low-occ-message="${holiday.ExclusionText}" ${Number(holiday.PriceModifierID) === Number(availability.el.selectedPriceModifierId.value) ? "selected" : ""}>${holiday.LowOccDiscountTitle}</option>`;
                }
            })
            .join("");
    } else {
        el.selectedPriceModifierId.value = "0";
    }

    // -------------------------------------------------------------------------------------------------------  CancelAnytime

    if (el.cancelAnytimePricing) {
        // update CA form values if available
        if (activeHolidayData.caPolicy) {
            el.selectedCancelAnytimeId.value =
                selectedCancellationValue === "flexible"
                    ? activeHolidayData.caPolicy?.id
                    : "0";
            el.selectedCancelAnytimeTotalCost.value =
                selectedCancellationValue === "flexible"
                    ? activeHolidayData.caPolicy.coverCost
                    : "0";
        } else {
            el.selectedCancelAnytimeId.value = "0";
            el.selectedCancelAnytimeTotalCost.value = "0";
        }
    }

    if (activeHolidayData.caPolicy && canReserve) {
        el.cancelAnytimePricing.ariaHidden = "false";
        el.caStandardPrice.textContent = formatPrice(activeHolidayData.Price);
        el.caFlexiblePrice.textContent = formatPrice(
            parseFloat(activeHolidayData.Price) +
            parseFloat(activeHolidayData.caPolicy.coverCost),
        );
        el.caFlexibleDescription.textContent =
            activeHolidayData.caPolicy.description;
    }

    // -------------------------------------------------------------------------------------------------------  Price Breakdown
    if (canReserve) {
        el.pricingBreakdownWrapper.ariaHidden = "false";
        el.pricingBreakdownWrapper.innerHTML = "";
        if (!activeHolidayData.caPolicy) {
            el.pricingBreakdownWrapper.innerHTML += `<div><p class="inline-accent">Rental price:</p> <p>${formatPrice(activeHolidayData.Price)}</p></div>`;
        }
        Array.from(activeHolidayData.lineItems?.lineItem ?? []).forEach(
            (lineItem) => {
                el.pricingBreakdownWrapper.innerHTML += `<div><p class="inline-accent">${lineItem.description}:</p> <p>${formatPrice(lineItem.value)}</p></div>`;
            },
        );

        const total =
            parseFloat(activeHolidayData.Price) +
            lineItemsTotal +
            (selectedCancellationValue === "flexible" && activeHolidayData.caPolicy
                ? parseFloat(activeHolidayData.caPolicy.coverCost)
                : 0);
        el.pricingBreakdownWrapper.innerHTML += `<div><p class="inline-accent booking-total">Your ${pricingData.HolidayDesc}:</p> <p class="booking-total">${formatPrice(total)}</p></div>`;
    }

    // toggle the reserve button based on canReserve
    availability.el.reserveButton.ariaHidden = !canReserve;

    // set the reserve button text based on the ReservationOffer value
    availability.el.reserveButton.value =
        pricingData.ReservationOffer > 0
            ? `Reserve now for £${pricingData.ReservationOffer}`
            : `Book now`;
};

availability.onReturnHolidayPricingResults = function (xml) {
    let result;
    if ($(xml).find("Result").length < 1) {
        alert("No holiday pricing options found");
    } else {
        $(xml)
            .find("Result")
            .each(function () {
                result = this;
                availability.recordPricing(this);
            });
    }
    return result;
};

availability.recordPricing = function (data) {
    // Push response from pricing feed to the dataLayerQueue, exposing it for use in TagManager.
    var result = data;
    var pricedHolidays = data.getElementsByTagName("pricedHoliday");

    var fullPrice =
        pricedHolidays.length > 0 ? pricedHolidays[0].getAttribute("Price") : 0;
    var holidayDesc = result.getAttribute("HolidayDesc");
    var showRent = result.getAttribute("ShowRent") === "Y";
    var canReserve = result.getAttribute("CanReserve") === "Y";
    var warning = result.getAttribute("WarningMessage");

    var startDate = availability.calendarFromDate;
    var endDate = availability.calendarToDate;
    var nights = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
    var startDateFMT = [
        startDate.getFullYear(),
        ("0" + (startDate.getMonth() + 1)).slice(-2),
        ("0" + startDate.getDate()).slice(-2),
    ].join("-");

    window.dataLayerQueue.push({
        event: "priceLookup",
        cottageCode: this.cottageCode,
        arrivalDate: startDateFMT,
        nights: nights,
        price: fullPrice,
        warningMessage: warning,
        canReserve: canReserve,
    });
};

function formatNumberLength(num, length) {
    var r = "" + num;
    while (r.length < length) {
        r = "0" + r;
    }
    return r;
}

availability.getHolidayReservationData = function () {
    var year = availability.calendarFromDate.getFullYear();
    var fromDate =
        availability.calendarFromDate.getDate() +
        "/" +
        (availability.calendarFromDate.getMonth() + 1) +
        "/" +
        availability.calendarFromDate.getFullYear();
    var toDate =
        availability.calendarToDate.getDate() +
        "/" +
        (availability.calendarToDate.getMonth() + 1) +
        "/" +
        availability.calendarToDate.getFullYear();
    var data =
        "&c=" +
        year +
        formatNumberLength(availability.cottageCode, 4) +
        "&h=" +
        fromDate +
        "," +
        toDate;
    data += "&business=ah";
    return data;
};

availability.onHoverDate = function (event, dateSquare) {
    if ($(dateSquare).hasClass("past-date")) {
        return;
    }

    // If dates are selected, don't respond to hover.
    if (
        availability.calendarFromDate != null &&
        availability.calendarToDate != null
    ) {
        return;
    }
    var hoverFromDate;
    var hoverToDate;
    if (availability.calendarFromDate == null) {
        //If this is the start date and is the begining of an unavailable period, just return
        if ($(dateSquare).hasClass("a-ava-una")) return;

        //First click sets the Arrival date.
        dateItems = dateSquare.attr("id").split("-");
        hoverFromDate = new Date(dateItems[0], dateItems[1], dateItems[2]);
        hoverToDate = new Date(hoverFromDate);
    } else {
        //Second click sets the Departure date.
        dateItems = dateSquare.attr("id").split("-");
        hoverFromDate = new Date(availability.calendarFromDate);
        hoverToDate = new Date(dateItems[0], dateItems[1], dateItems[2]);
    }
    availability.clearHighlight(true);
    availability.highlightDateRange(hoverFromDate, hoverToDate, true);
};

availability.highlightDateRange = function (dfrom, dto, hover) {
    if (dfrom == null && dto == null) {
        return;
    }
    if (!dto) {
        dto = new Date(dfrom);
    }
    var d = new Date(dfrom);
    while (d <= dto) {
        var dsi = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
        var dateSquare = jQuery("#" + dsi);
        if (dateSquare) {
            //Is this the first or last square in the range?
            var isFirst =
                d.getDate() == dfrom.getDate() && d.getMonth() == dfrom.getMonth();
            var isLast =
                d.getDate() == dto.getDate() && d.getMonth() == dto.getMonth();
            var curState = availability.getState(dateSquare);

            var statePart;
            hover ? (statePart = "hvr") : (statePart = "sel");

            var newState;
            if (isFirst) {
                newState = curState.substring(0, 3) + "-" + statePart;
            } else if (isLast) {
                newState =
                    statePart +
                    "-" +
                    curState.substring(curState.length - 3, curState.length);
            } else {
                newState = statePart;
            }
            availability.setState(dateSquare, newState);

            // persist changed cells so we can efficiently revert when the selection is cleared.
            if (hover) {
                dateSquare.noHvrClassName = curState;
                availability.hvrCells[availability.hvrCells.length] = dateSquare;
            } else {
                dateSquare.noSelClassName = curState;
                availability.selCells[availability.selCells.length] = dateSquare;
            }
        }
        d.setDate(d.getDate() + 1);
    }
};

availability.clearHighlight = function (hover) {
    var arrayOfCells;
    arrayOfCells = hover ? availability.hvrCells : availability.selCells;
    for (i = 0; i < arrayOfCells.length; i++) {
        if (arrayOfCells[i]) {
            var dateSquare = jQuery(arrayOfCells[i]);
            var oldState;
            if (hover) {
                oldState = arrayOfCells[i].noHvrClassName;
                arrayOfCells[i].noHvrClassName = null;
            } else {
                oldState = arrayOfCells[i].noSelClassName;
                arrayOfCells[i].noSelClassName = null;
            }
            availability.setState(dateSquare, oldState);
        }
    }
    if (hover) {
        availability.hvrCells = [];
    } else {
        availability.selCells = [];
    }
};

availability.setState = function (dateSquare, newState) {
    //Remove existing availability state className (prefixed 'a-').
    var stateClassName;
    var currentClassNames = dateSquare.attr("class");
    if (currentClassNames) {
        var ccn = currentClassNames.split(" ");
        for (var index = 0; index < ccn.length; index++) {
            if (ccn[index].indexOf("a-") == 0) {
                dateSquare.removeClass(ccn[index]);
            }
        }
    }
    //Set the new classname
    dateSquare.addClass("a-" + newState);
};

availability.getState = function (dateSquare) {
    //Retrieve existing availability state className (prefixed 'a-').
    var stateClassName;
    var currentClassNames = dateSquare.attr("class");
    if (currentClassNames) {
        var ccn = currentClassNames.split(" ");
        for (var index = 0; index < ccn.length; index++) {
            if (ccn[index].indexOf("a-") == 0) {
                return ccn[index].replace("a-", "");
            }
        }
    }
    return "";
};

// -------------------- utility functions

const formatPrice = (amount) =>
    `£${parseFloat(amount).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const xmlToJson = function (node) {
    const json = {};
    if (node?.attributes && node.attributes.length) {
        Array.from(node.attributes).forEach(function (attribute) {
            json[attribute.name] = attribute.value;
        });
    }
    Array.from(node?.children || []).forEach(function (child) {
        const childJson = xmlToJson(child);
        const childName = child.nodeName;

        if (json[childName]) {
            if (!Array.isArray(json[childName])) {
                json[childName] = [json[childName]];
            }
            json[childName].push(childJson);
        } else {
            json[childName] = childJson;
        }
    });
    return json;
};

// -------------------- init availability calendar

(function () {
    if ($('#book-form').length === 0) return;
    availability.initElements();

    var cottageCode = $("#cottageCode").val();
    var year = $("#year").val();
    availability.showCalendars(year, cottageCode);

    availability.el.lowOccSelect.addEventListener("change", function (event) {
        // set hiddden form value
        availability.el.selectedPriceModifierId.value = event.target.value;
        // update global var
        availability.activePriceModifierId = parseInt(event.target.value);

        // render choices in aside
        availability.renderPriceBreakdown();

        // display the low occupancy message if it exists for the selected option
        availability.el.lowOccMessage.textContent =
            event.target.options[event.target.selectedIndex].dataset.lowOccMessage ||
            "";
    });

    if (availability.el.cancelAnytimePricing) {
        availability.el.cancelAnytimePricing.onchange = (event) => {
            // render choices in aside
            availability.renderPriceBreakdown();
        };
    }
})();
